// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nselect[data-v-858769e4] {\n  width: 150px\n}\nselect option[value=\"\"][disabled][data-v-858769e4] {\n display: none;\n}\n.popup_wrap[data-v-858769e4]{\n  -ms-overflow-style: none;\n}\n.popup_wrap[data-v-858769e4]::-webkit-scrollbar{\n  display:none;\n}\n.txt_size_bk[data-v-858769e4] {\n    color: black;\n    text-align: left;\n    margin-top: 5px;\n    font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
